var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHatchback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.26 11.914l-4.333-.722-4.336-2.168A.226.226 0 0012.489 9H6.666a.227.227 0 00-.136.045L3.619 11.23l-.016.013-.011.01a.242.242 0 00-.02.025l-.006.008a.211.211 0 00-.02.035l-.004.014-.008.022-.727 2.91a.227.227 0 00.119.26l1.455.727a.224.224 0 00.102.024h.071a1.682 1.682 0 002.768 0h9.605a1.681 1.681 0 002.768 0h.799c.035 0 .07-.008.102-.024l1.455-.728a.228.228 0 00.126-.203v-1.456a.227.227 0 00-.067-.16l-.728-.728a.222.222 0 00-.122-.064zm-8.825-2.459l3.457 1.728H9.165l.577-1.728h2.693zm-5.693 0h2.52l-.576 1.728H4.437l2.305-1.728zm-.804 6.095a1.23 1.23 0 01-1.228-1.228 1.23 1.23 0 011.228-1.228 1.23 1.23 0 011.229 1.228 1.23 1.23 0 01-1.229 1.228zm12.373 0a1.23 1.23 0 01-1.228-1.228 1.23 1.23 0 011.228-1.228 1.23 1.23 0 011.228 1.228 1.23 1.23 0 01-1.228 1.228z",
    fill: "#0B0B0B",
    fillRule: "evenodd"
  })));
}

export default SvgHatchback;